import React from 'react';
import classNames from 'classnames';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';

import styles from './RangeSlider.module.scss';

export const RangeSliderComponent = ({
  min = 0,
  max = 100,
  value,
  onChange,
  tickLabels,
  className,
}) => (
  <div className={classNames(styles.wrapper, className)}>
    <input
      type="range"
      min={min}
      max={max}
      value={value}
      onChange={(e) => onChange?.(Number(e.target.value))}
      className={styles.range}
    />
    {tickLabels && (
      <div className={styles.ticks}>
        {tickLabels.map((label) => (
          <Text
            key={label}
            variant={textVariantsEnum.Text_xs}
            fontWeight={fontWeightEnum.Normal}
            color="gray-500"
          >
            {label}
          </Text>
        ))}
      </div>
    )}
  </div>
);

RangeSliderComponent.displayName = 'RangeSlider';
